<template>
	<div>
		<div>{{ label }} <span v-if="mode && unit && !isSquareFoot"> ({{ unit }})</span> <span v-if="mode && unit && isSquareFoot"> (ft<sup>2</sup>)</span> </div>
		<div v-if="mode">
			<input
				type="number"
				:value="inputValue"
				style="width: 100%"
				:step="inputStep"
				@input="handleInput"
			>
		</div>
		<div v-if="!mode" style="text-align: right">
			<hr style="border-top: 1px solid rgba(0, 0, 0); margin: 0px;">
			<span v-if="isCurrency">{{ unit }}</span>
			{{ inputValue | numberFormat }}
			<span v-if="isSquareFoot">ft<sup>2</sup></span>
			<span v-if="!isSquareFoot && !isCurrency">{{ unit }}</span> 
		</div>
	</div>
</template>

<script>
export default {
    name: 'FieldInput',
    filters: {
        numberFormat(number) {
            const numberFormatter = Intl.NumberFormat('en-US');
            const formatted = numberFormatter.format(number);
            return formatted;
		},
    },
    props: {
        mode: {
            type: Boolean,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        step: {
            type: Number,
            required: false,
            default: 1
        },
        unit: {
            type: String,
            required: false,
            default: ''
        },
    },
    data() {
        return {
            inputValue: this.value,
            inputStep: this.step,
            currencies: [
                '$', '£', '€', '¥', '₣'
            ],
            isCurrency: false,
            isSquareFoot: false,
        }
    },
    computed: {

    },
    watch: {
        value: {
			immediate: true,
			handler(newVal) {
				this.inputValue = newVal;
			},
		},
        unit: {
			immediate: true,
			handler(newVal) {
                if (newVal === 'ft.^2')  this.isSquareFoot = true;
                if (this.currencies.includes(newVal)) this.isCurrency = true;
			},
		}
    },
    methods: {
        handleInput(event) {
            if (this.inputStep === 1) {
                this.inputValue = parseInt(event.target.value, 10);
                this.$emit('input', parseInt(event.target.value, 10));
            } else {
                this.inputValue = parseFloat(event.target.value);
                this.$emit('input', parseFloat(event.target.value));
            }
        }
    },
}
</script>